import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, pacienteJsonHeaders } from '../../services/pacienteConfig';
import './PacienteCambiarPasswordPage.css';

const PacienteCambiarPasswordPage = () => {
  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNuevo, setPasswordNuevo] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [showPasswords, setShowPasswords] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (passwordNuevo.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres.');
      return;
    }

    if (passwordNuevo !== passwordConfirm) {
      setError('Las contraseñas nuevas no coinciden.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API}/paciente/cambiar-password`, {
        method: 'POST',
        headers: pacienteJsonHeaders(),
        body: JSON.stringify({
          password_actual: passwordActual,
          password_nuevo: passwordNuevo,
          password_nuevo_confirmation: passwordConfirm,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        navigate('/paciente');
      } else {
        setError(data.error || data.message || 'Error al cambiar la contraseña.');
      }
    } catch (err) {
      setError('Error de conexión. Intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-widget-container login-bg-abstract paciente-cambiar-password-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">🔒</div>
          <h2>Cambio de Contraseña</h2>
          <div className="security-notice">
            <p>Por seguridad, debes cambiar tu contraseña temporal antes de continuar.</p>
          </div>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="passwordActual">Contraseña Actual (Temporal)</label>
            <div className="password-input-wrapper">
              <input
                id="passwordActual"
                type={showPasswords ? 'text' : 'password'}
                value={passwordActual}
                onChange={(e) => setPasswordActual(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="passwordNuevo">Nueva Contraseña</label>
            <div className="password-input-wrapper">
              <input
                id="passwordNuevo"
                type={showPasswords ? 'text' : 'password'}
                value={passwordNuevo}
                onChange={(e) => setPasswordNuevo(e.target.value)}
                required
                minLength="6"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="passwordConfirm">Confirmar Nueva Contraseña</label>
            <div className="password-input-wrapper">
              <input
                id="passwordConfirm"
                type={showPasswords ? 'text' : 'password'}
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                required
                minLength="6"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPasswords(!showPasswords)}
              >
                {showPasswords ? '👁️‍🗨️' : '👁️'}
              </button>
            </div>
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar y Continuar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PacienteCambiarPasswordPage;
